import { create } from "zustand"

interface DocumentEditorState {
  chatBusy: boolean
  dirty: boolean
  save: (() => Promise<boolean>) | null
  setChatBusy: (chatBusy: boolean) => void
  setDirty: (dirty: boolean) => void
  registerSave: (save: (() => Promise<boolean>) | null) => void
  reset: () => void
}

const initialState = { chatBusy: false, dirty: false, save: null }

export const useDocumentEditorStore = create<DocumentEditorState>((set) => ({
  ...initialState,
  setChatBusy: (chatBusy) => set({ chatBusy }),
  setDirty: (dirty) => set({ dirty }),
  registerSave: (save) => set({ save }),
  reset: () => set(initialState),
}))
